var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
export default function isTransform(value) {
  return !!(value && supportedTransforms.test(value));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/node_modules/dom-helpers/esm/isTransform.js
// module id = 296
// module chunks = 1